import { localizeReaderText } from './readerTerminology';

const adminCopy = {
  en: {
    eyebrow: 'Owner access',
    title: 'Fate Room admin portal',
    body: 'Restricted operational access for managing users, tellers, sessions, bookings, cancellations, and booking dates.',
    email: 'Admin email',
    password: 'Password',
    login: 'Log in as admin',
    checking: 'Checking admin session...',
    restricted: 'This admin portal is restricted to the approved owner account.',
    wrongAccount: 'Admin login is allowed only for',
  },
  sk: {
    eyebrow: 'Prístup prevádzkovateľa',
    title: 'Administračný portál Fate Room',
    body: 'Chránený prevádzkový prístup na správu používateľov, tellerov, stretnutí, rezervácií, zrušení a termínov.',
    email: 'E-mail administrátora',
    password: 'Heslo',
    login: 'Prihlásiť sa ako administrátor',
    checking: 'Kontroluje sa administrátorská relácia...',
    restricted: 'Tento administračný portál je prístupný iba schválenému účtu prevádzkovateľa.',
    wrongAccount: 'Prihlásenie administrátora je povolené iba pre účet',
  },
  cs: {
    eyebrow: 'Přístup provozovatele',
    title: 'Administrační portál Fate Room',
    body: 'Chráněný provozní přístup ke správě uživatelů, tellerů, setkání, rezervací, zrušení a termínů.',
    email: 'E-mail administrátora',
    password: 'Heslo',
    login: 'Přihlásit se jako administrátor',
    checking: 'Kontroluje se administrátorská relace...',
    restricted: 'Tento administrační portál je přístupný pouze schválenému účtu provozovatele.',
    wrongAccount: 'Přihlášení administrátora je povoleno pouze pro účet',
  },
  es: {
    eyebrow: 'Acceso del operador',
    title: 'Portal de administración de Fate Room',
    body: 'Acceso operativo protegido para gestionar usuarios, lectores, sesiones, reservas, cancelaciones y fechas.',
    email: 'Correo del administrador',
    password: 'Contraseña',
    login: 'Iniciar sesión como administrador',
    checking: 'Comprobando la sesión de administración...',
    restricted: 'Este portal de administración está reservado a la cuenta aprobada del operador.',
    wrongAccount: 'El acceso de administración solo está permitido para la cuenta',
  },
  pt: {
    eyebrow: 'Acesso do operador',
    title: 'Portal de administração do Fate Room',
    body: 'Acesso operacional protegido para gerir utilizadores, consultores, sessões, reservas, cancelamentos e datas.',
    email: 'E-mail do administrador',
    password: 'Palavra-passe',
    login: 'Iniciar sessão como administrador',
    checking: 'A verificar a sessão de administração...',
    restricted: 'Este portal de administração está reservado à conta aprovada do operador.',
    wrongAccount: 'O acesso de administração só é permitido para a conta',
  },
};

export const getAdminCopy = (language) => localizeReaderText(adminCopy[language] || adminCopy.en, language);
